import { useFileDownload as useFileDownloadREST } from '@risksmart-app/components/src/file/useFileDownload';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';

import { useFileDownloadTRPC } from './useFileDownloadTRPC';

/**
 * Flag-gated wrapper over the V2 REST download flow
 * (`@risksmart-app/components/src/file/useFileDownload`) and its tRPC twin.
 * Consumers import THIS — never `useFileDownloadTRPC` directly.
 *
 * The public-policy download paths (`src/pages/files/config.ts`,
 * `OpenPublicPolicyFilePage`) intentionally stay on the V2 REST hook — the
 * tRPC `getDownloadUrl` permission-gates via the data-layer file read, which
 * public-link semantics must bypass.
 *
 * Bespoke by decision (RSP-6330): NOT built with `createMutationHook`. The
 * legacy branch is a REST flow, not an Apollo document, and the download is
 * a fetch-then-navigate action rather than a cache-invalidating mutation.
 * The `*TRPC` twin therefore stays as a separate file with its own direct
 * test.
 */
export const useFileDownload = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  const restDownload = useFileDownloadREST();
  const trpcDownload = useFileDownloadTRPC();

  return trpcEnabled ? trpcDownload : restDownload;
};
